import { Link } from 'react-router-dom'
import { useAsync } from '../hooks/useAsync'
import { fetchLeagueUpdates } from '../services/league'
import { Card, EmptyState, Loading, Notice, formatDate } from '../components/ui'
import UpdateBody from '../components/UpdateBody'
import './Updates.css'

/**
 * The dated archive of league and season updates.
 *
 * @remarks
 * Includes posts that have been taken off the homepage. The front page only
 * ever shows the newest one; this page is the rest of the record.
 */
export default function Updates() {
  const updates = useAsync(fetchLeagueUpdates, [])

  return (
    <div className="stack">
      <header className="page-header">
        <div>
          <span className="eyebrow">Updates</span>
          <h1>League news</h1>
          <p>
            Season notes, schedule changes, and everything posted to the front page. The
            website’s own release history is on{' '}
            <Link className="player__name--link" to="/changelog">
              Changelog
            </Link>
            .
          </p>
        </div>
      </header>

      {updates.error && <Notice tone="error">{updates.error}</Notice>}

      {updates.loading ? (
        <Loading rows={4} />
      ) : updates.data && updates.data.length > 0 ? (
        <ol className="update-archive">
          {updates.data.map(update => (
            <li key={update.id}>
              <article className="update-post">
                <time className="update-post__date" dateTime={update.postedAt}>
                  {formatDate(update.postedAt)}
                  {update.editedAt && (
                    <span className="update-post__edited">Edited {formatDate(update.editedAt)}</span>
                  )}
                </time>
                <div className="update-post__body">
                  <h2 className="update-post__title">
                    {update.title}
                    {update.onHomepage && <span className="update-post__live">On homepage</span>}
                  </h2>
                  <UpdateBody text={update.body} />
                </div>
              </article>
            </li>
          ))}
        </ol>
      ) : (
        <Card>
          <EmptyState title="No updates yet">
            Admins can post league and season news from the Admin page. The newest one appears on
            the front page.
          </EmptyState>
        </Card>
      )}
    </div>
  )
}
